export const MANAGE_PROFILE = 'manageProfile';
export const SIGN_OUT = 'signOut';
export const SIGN_IN = 'signIn';
export const SKY_GO_ABOUT = 'about';
export const MY_HUB = 'myHub';
export const REGISTER = 'Register';
